import { declension } from "./functions.js";

$(document).ready(function () {
  $(".polls__btn").click(function () {
    let docId = $("input[type='hidden']").data("docid");
    const checkedRadio = $(".bk__polls__checkbox:checked").val();

    $.ajax({
      method: "POST",
      url: "ajax/bksetvote",
      data: { docId: docId, checkedRadio: checkedRadio },
    }).done(function (resp) {
      $(".custom__section--vote").css("display", "none");
      $(".custom__section--vote__result").css("display", "block");
      let respObj = jQuery.parseJSON(resp);

      if (respObj.type === "success") {
        $.jGrowl(respObj.message, { theme: "tickets-message-success" });

        const instance = tippy(
          document.querySelector(
            "." + checkedRadio + " .bk__polls__result__progress"
          )
        );

        instance.setContent(
          respObj.newVal +
            " " +
            declension("голос", "голосов", "голоса", respObj.newVal)
        );

        $("." + checkedRadio)
          .find(".bk__polls__result__progress__value")
          .css("width", respObj.newVal + "%");

        const newVal =
          respObj.newVal +
          " " +
          declension("голос", "голосов", "голоса", respObj.newVal);

        $("." + checkedRadio)
          .find(".bk__polls__result__votes")
          .html(newVal);
      } else if (respObj.type === "error") {
        $.jGrowl(respObj.message, { theme: "tickets-message-error" });
      }
    });

    return false;
  });
});
